import type { SingleMarketTemplate, TemplateView } from '@ps/isp-web-services-types';

export const isSingleMarketTemplate = (
  template: TemplateView['template']
): template is SingleMarketTemplate => 'marketId' in template;
